"use strict";

exports.__esModule = true;
exports.StripeChartCanvas = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _StripeChartCanvas = require("./StripeChartCanvas.legacy");
var _StripeChartCanvas2 = require("./StripeChartCanvas.modern");
// Flag-gated UI: `StripeChartCanvas.legacy` is the component as it is on master,
// `StripeChartCanvas.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var StripeChartCanvas = exports.StripeChartCanvas = (0, _uiSwitch.uiSwitch)(_StripeChartCanvas.StripeChartCanvas, _StripeChartCanvas2.StripeChartCanvas, "StripeChartCanvas");